/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { UtenteService } from '@shared/services/utente.service';

@Injectable({
    providedIn: 'root'
})
export class CoreAuthGuard implements CanActivate, CanActivateChild {

    constructor(
        private utenteService: UtenteService,
        private router: Router,
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        if (!this.utenteService.logged) {
            this.utenteService.redirectUrl = state.url;
            this.router.navigate(['/auth']);
            return false;
        }
        return true;
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        return this.canActivate(next, state);
    }

}
